import { getAuth } from "firebase/auth";
import firebaseApp from "../firebase/app";

export const getIdTokenKeyFromFirebase = async (): Promise<
  string | undefined
> => {
  const auth = getAuth(firebaseApp);
  return auth.currentUser?.getIdToken();
};
